module.exports = __webpack_public_path__ + "img/herring_gear.prt.1be40f88.jpg";